import { gql } from '@apollo/client'

export const SUB_ACTIVITIES_LIST_QUERY = gql`
  query SUB_ACTIVITIES_LIST_QUERY($filter: LogFilterInput!) {
    logs(filter: $filter) {
      data {
        id
        actionType
        createdAt
        entityType
        metadata {
          fileName
          fileUrl
          fileContentType
          comment
        }
        user {
          id
          firstName
          lastName
          avatarUrl
        }
      }
    }
  }
`
